import React, {useState, useEffect} from 'react';
import { credientials } from "../credientials";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const CheckInvoice =(props) =>{

    const [invoiceCheck, setInvoiceCheck] = useState(false);
    const [datePaid, setDatePaid] = useState('');
    let dollars = "$" + (props.amount / 100).toFixed(2);

    const paymentOptions = {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "Amount": props.amount,
          "Invoice": props.invoice,
          "Client": props.client,
          "Action": "Check"
          
        }),
      };
      useEffect(() => {
        
            fetch(credientials.CheckInvoiceUrl, paymentOptions)
            .then(response => {
                return response.json().then(data =>{
                    console.log(data);
                    if(data.error){
                        setInvoiceCheck(true);
                        setDatePaid(data.date);
                    }else{
                        
                        setInvoiceCheck(false);
                    }
                });
            });
      }, []);
      console.log(invoiceCheck);

        return(
            <>
            <Modal
                open={invoiceCheck}
                //onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="checkInvoiceBox"
            >
                <Box sx={props.style}>
                <Typography id="modal-modal-description" sx={{ mt: 2, mb:3 }} textAlign="center">
                    <CheckCircleRoundedIcon sx={{ fontSize: 60 }} color="success" />
                    </Typography>
                    <Typography id="modal-modal-title" variant="h4" component="h2" alignItems="center" textAlign="center"sx={{ mt: 2, mb:3 }}>
                        Good News 
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="p" alignItems="center" textAlign="center" sx={{ mb:3 }}>
                    This invoice has already been paid
                    </Typography>
                    
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead sx={{backgroundColor:'#dee2e6'}}>
                            <TableRow>
                                <TableCell align="center">Invoice No</TableCell>
                                <TableCell align="center">Client No</TableCell>
                                <TableCell align="center">Amount</TableCell>
                                <TableCell align="center">Date Paid</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                <TableCell align="center">{props.invoice}</TableCell>
                                <TableCell align="center">{props.client}</TableCell>
                                <TableCell align="center">{dollars}</TableCell>
                                <TableCell align="center">{datePaid}</TableCell>
                                
                            
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>

                    
                    <Typography id="modal-modal-title" variant="body1" component="p" alignItems="center" textAlign="center"sx={{ mb:3, mt: 3 }}>
                    If you believe this to be a mistake please contact
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="p" alignItems="center" textAlign="center" sx={{ mb:3 }} >
                    <a href="mailto:AReceivable@cerebralpalsy.org.au">Accounts Receivable</a> 
                    </Typography>
                </Box>
        </Modal>
            </>
        )
    

}